export const en = {
  discardRefresh: 'Discard local edits and refresh',
  title: 'Policies',
  description:
    'Choose screening checks and risk impacts for your organization. Published changes apply to future submissions.',
  individual: 'Individual',
  company: 'Company',
  member: 'Key members',
  SANCTIONS: 'Sanctions',
  PEP_SCREENING: 'Politically exposed persons',
  ADVERSE_MEDIA: 'Adverse media',
  JURISDICTION_RISK: 'Jurisdiction risk',
  SOCIAL: 'Social signals',
  NONE: 'No increase',
  MEDIUM: 'Medium',
  HIGH: 'High',
  seriousFinancialCrime: 'Serious financial crime',
  discrepancy: 'Documented discrepancies',
  informational: 'Informational finding',
  impact: 'Risk impact',
  enabled: 'Enabled',
  disabled: 'Disabled',
  draft: 'Draft settings',
  active: 'Active settings',
  defaults: 'Raven defaults',
  save: 'Save draft',
  publish: 'Publish saved draft',
  saved: 'Draft saved',
  published: 'Policy published',
  history: 'Published versions',
  noHistory: 'No custom policy has been published yet.',
  changes: 'Changes from active settings',
  noChanges: 'No changes from active settings.',
  unsaved: 'You have unsaved policy changes.',
  minimum: 'Enable at least one category in every profile.',
  publishNote:
    'Review the changes below before publishing. Existing reports and retries keep their original policy. Save your draft before publishing.',
  exceptions:
    'Informational findings never increase risk. Discrepancies override category impact; serious financial crime overrides adverse-media impact.',
  applied: 'Applied policy',
  legacy: 'Legacy Raven policy',
  coverage: 'Screening coverage by subject',
  not_screened: 'Not screened by policy',
  researched: 'Researched',
  no_findings: 'Researched — no findings',
  insufficient_evidence: 'Insufficient evidence',
  inaccessible: 'Sources inaccessible',
  failed: 'Check failed',
  appliedRule: 'Applied rule',
  publisher: 'Published by',
  draftAuthor: 'Draft last edited by',
  loadError: 'Unable to load policies.',
  retry: 'Refresh',
  loading: 'Loading policies…',
} as const;
export const fa: Record<keyof typeof en, string> = {
  discardRefresh: 'حذف ویرایش‌های محلی و تازه‌سازی',
  title: 'سیاست‌ها',
  description:
    'بررسی‌ها و تأثیر آن‌ها بر ریسک را برای سازمان خود تعیین کنید. تغییرات منتشرشده برای ارسال‌های بعدی اعمال می‌شوند.',
  individual: 'شخص حقیقی',
  company: 'شرکت',
  member: 'اعضای کلیدی',
  SANCTIONS: 'تحریم‌ها',
  PEP_SCREENING: 'اشخاص دارای سمت سیاسی',
  ADVERSE_MEDIA: 'اخبار منفی',
  JURISDICTION_RISK: 'ریسک حوزه قضایی',
  SOCIAL: 'نشانه‌های اجتماعی',
  NONE: 'بدون افزایش',
  MEDIUM: 'متوسط',
  HIGH: 'بالا',
  seriousFinancialCrime: 'جرائم مالی جدی',
  discrepancy: 'مغایرت‌های مستند',
  informational: 'یافته اطلاعاتی',
  impact: 'تأثیر بر ریسک',
  enabled: 'فعال',
  disabled: 'غیرفعال',
  draft: 'تنظیمات پیش‌نویس',
  active: 'تنظیمات فعال',
  defaults: 'پیش‌فرض‌های ریون',
  save: 'ذخیره پیش‌نویس',
  publish: 'انتشار پیش‌نویس ذخیره‌شده',
  saved: 'پیش‌نویس ذخیره شد',
  published: 'سیاست منتشر شد',
  history: 'نسخه‌های منتشرشده',
  noHistory: 'هنوز سیاست سفارشی منتشر نشده است.',
  changes: 'تغییرات نسبت به تنظیمات فعال',
  noChanges: 'تغییری نسبت به تنظیمات فعال وجود ندارد.',
  unsaved: 'تغییرات ذخیره‌نشده در سیاست دارید.',
  minimum: 'حداقل یک دسته را در هر نمایه فعال کنید.',
  publishNote:
    'پیش از انتشار، تغییرات زیر را بررسی کنید. گزارش‌های موجود و تلاش‌های مجدد، سیاست اصلی خود را حفظ می‌کنند. ابتدا پیش‌نویس را ذخیره کنید.',
  exceptions:
    'یافته‌های اطلاعاتی ریسک را افزایش نمی‌دهند. مغایرت‌ها بر تأثیر دسته اولویت دارند؛ جرائم مالی جدی بر تأثیر اخبار منفی اولویت دارند.',
  applied: 'سیاست اعمال‌شده',
  legacy: 'سیاست پیشین ریون',
  coverage: 'پوشش بررسی به تفکیک موضوع',
  not_screened: 'طبق سیاست بررسی نشده',
  researched: 'بررسی‌شده',
  no_findings: 'بررسی‌شده — بدون یافته',
  insufficient_evidence: 'شواهد ناکافی',
  inaccessible: 'منابع غیرقابل دسترسی',
  failed: 'بررسی ناموفق',
  appliedRule: 'قاعده اعمال‌شده',
  publisher: 'منتشرکننده',
  draftAuthor: 'آخرین ویرایش پیش‌نویس توسط',
  loadError: 'بارگذاری سیاست‌ها امکان‌پذیر نیست.',
  retry: 'تازه‌سازی',
  loading: 'در حال بارگذاری سیاست‌ها…',
};
